const REFERENCE_ASSETS = require('../reference-assets.js');

module.exports = {
    dai: {
        id: 'dai',
        type: REFERENCE_ASSETS.USD,
        symbol: 'DAI',
        decimals: 1e18,
        address: '0xda10009cbd5d07dd0cecc66161fc93d7c9000da1',
    },
    usdt: {
        id: 'usdt',
        type: REFERENCE_ASSETS.USD,
        symbol: 'USDT',
        decimals: 1e6,
        address: '0x94b008aa00579c1307b0ef2c499ad98a8ce58e58',
    },
    usdc: {
        id: 'usdc',
        type: REFERENCE_ASSETS.USD,
        symbol: 'USDC',
        decimals: 1e6,
        address: '0x7f5c764cbc14f9669b88837ca1490cca17c31607',
    },
    weth: {
        id: 'weth',
        type: REFERENCE_ASSETS.ETH,
        symbol: 'WETH',
        decimals: 1e18,
        address: '0x4200000000000000000000000000000000000006',
        coingeckoId: 'weth',
    },
    eth: {
        id: 'eth',
        type: REFERENCE_ASSETS.ETH,
        symbol: 'ETH',
        decimals: 1e18,
        address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
    },
    wsteth: {
        id: 'wsteth',
        type: REFERENCE_ASSETS.ETH,
        symbol: 'wstETH',
        decimals: 1e18,
        address: '0x1f32b1c2345538c0c6f582fcb022739c4a194ebb',
        coingeckoId: 'wrapped-steth',
    },
};
